import React, { useEffect } from "react";
import { TouchableOpacity } from "react-native";
import { Animated } from "react-native";
import { Text } from "react-native";
import { View, ActivityIndicator } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import styles from "./styles";

const ConfirmarDados = ({ confirmar, dispensar, fechar }) => {
  useEffect(() => {
    Animated.timing(_animated, {
      toValue: 1,
      duration: 200,
      useNativeDriver: false,
    }).start();

    Animated.timing(_animatedModal, {
      toValue: 280,
      duration: 250,
      useNativeDriver: false,
    }).start();
  });
  const _animated = new Animated.Value(0);
  const _animatedModal = new Animated.Value(0);

  return (
    <Animated.View style={[styles.overlay, { opacity: _animated }]}>
      <Animated.View style={[styles.modal, { height: _animatedModal }]}>
        <TouchableOpacity style={styles.close} onPress={fechar}>
          <Icon size={20} name="times" />
        </TouchableOpacity>
        <Text style={styles.textHeader}>
          Confirma o envio de seus contatos?
        </Text>
        <Text style={styles.text}>
          Iremos enviar seus dados de contato para a empresa que está oferecendo
          essa vaga.
        </Text>
        <Text style={styles.text}>
          Isso incluí seus telefones, endereço e redes sociais cadastradas no
          SenaiJob.
        </Text>
        <TouchableOpacity style={styles.buttonConfirm} onPress={confirmar}>
          <Text style={styles.textConfirm}>Sim, enviar meus contatos.</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={{ marginTop: 10, alignItems: "center" }}
          onPress={dispensar}
        >
          <Text style={{ fontWeight: "bold", color: "red" }}>
            Não, dispensar essa vaga.
          </Text>
        </TouchableOpacity>
      </Animated.View>
    </Animated.View>
  );
};

export default ConfirmarDados;
